import {ConclusionKeys, FindingAreasEnum, QuestionnaireFlowType, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";

const questionnaireBenefits: QuestionnaireFlowType = {
    id: FindingAreasEnum.Benefits,
    name: getFindingAreaDisplayText(FindingAreasEnum.Benefits),
    questions: [
        {
            id: `${FindingAreasEnum.Benefits}:Q1`,
            text: "Do you provide employees with non-cash taxable benefits?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.Benefits}:Q2A`,
                no: `${FindingAreasEnum.Benefits}:Q2C`,
            },
        },
        {
            id: `${FindingAreasEnum.Benefits}:Q2A`,
            text: "Do you declare these benefits for income tax and NIC purposes (this could be on Form P11D or directly via payroll)?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.Benefits}:Q3A`,
                no: `${FindingAreasEnum.Benefits}:Q3B`
                
            },
        },
        {
            id: `${FindingAreasEnum.Benefits}:Q2C`, //No conclusion risk rating is associated with this answer
            text: " Do you provide any benefits via salary sacrifice (taken as a deduction from gross pay)? If so, please provide some further details of what benefits are provided in this way.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {
                next: ConclusionKeys.Green
            }
        },
        {
            id: `${FindingAreasEnum.Benefits}:Q3A`,
            text: "Are filings and payments in relation to these benefits up-to-date?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.Benefits}:Q4A`,
                no: `${FindingAreasEnum.Benefits}:Q4B`,
            },
        },
        {
            id: `${FindingAreasEnum.Benefits}:Q3B`,
            text: " Do you provide any benefits via salary sacrifice (taken as a deduction from gross pay)? If so, please provide some further details of what benefits are provided in this way.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {
                next: ConclusionKeys.Red
            }
        },
        {
            id: `${FindingAreasEnum.Benefits}:Q4A`, //Note: Q4A and Q4B are the same and dont have a risk rating conclusion
            text: "Do you provide any benefits via salary sacrifice (taken as a deduction from gross pay)?  If so, please provide some further details of what benefits are provided in this way.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {
                next: ConclusionKeys.Green
            }
        },
        {
            id: `${FindingAreasEnum.Benefits}:Q4B`,
            text: "Do you provide any benefits via salary sacrifice (taken as a deduction from gross pay)?  If so, please provide some further details of what benefits are provided in this way.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {
                next: ConclusionKeys.Red
            }
        }
    ],
};

export default questionnaireBenefits;
